<template>
  <div class="scenario-3D">
    <img :src="data.url" />
  </div>
</template>

<script src="./Scenario3D.js"></script>
